import { $RTKGlobalAPI } from 'shared/store'
import { Tags } from 'shared/store/types/api'
import { RequestMethod } from 'shared/types/Api'

import { apiRoutes } from 'shared/config/apiPath/apiPath'

import {
  GetSearchAutoCompleteArgs,
  GetSearchAutoCompleteResponse,
  GetSearchQueriesResponse,
  SetSearchQueryArgs,
} from './types'

const query = $RTKGlobalAPI.injectEndpoints({
  endpoints: builder => ({
    getSearchQueries: builder.query<GetSearchQueriesResponse, void>({
      query: () => ({
        url: apiRoutes.search.getSearchQueries,
      }),
      providesTags: [Tags.SEARCH],
    }),
    getSearchAutoComplete: builder.query<
      GetSearchAutoCompleteResponse,
      GetSearchAutoCompleteArgs
    >({
      query: query => ({
        url: apiRoutes.search.getSearchAutoComplete,
        params: query,
      }),
    }),
    deleteSearchQuery: builder.mutation<GetSearchQueriesResponse, string>({
      query: id => ({
        url: apiRoutes.search.deleteSearchQuery(id),
        method: RequestMethod.DELETE,
      }),
      invalidatesTags: [Tags.SEARCH],
    }),
    setSearchQuery: builder.mutation<
      GetSearchQueriesResponse,
      SetSearchQueryArgs
    >({
      query: body => ({
        url: apiRoutes.search.setSearchQuery,
        method: RequestMethod.POST,
        body,
      }),
      invalidatesTags: [Tags.SEARCH],
    }),
  }),
})

export const {
  useGetSearchQueriesQuery,
  useDeleteSearchQueryMutation,
  useSetSearchQueryMutation,
  useGetSearchAutoCompleteQuery,
  endpoints: mainPageEndpoints,
} = query
